module.exports = __webpack_public_path__ + "static/media/flask_laboratory.1b7fbb70.svg";